import React, { useState } from 'react';

import Selectors from '@sharedComponent/app-action-reducer/selectors';
import { connect } from 'react-redux';
import CreateCommissionReportPresentational from './create-commission-report-presentational';

const CreateCommissionReportFunctional = ({ userDetails,
	// getCommissionSummaryByID 
}) => {
	const [state, setState] = useState({
		loading: false,
	});
	// const [request, setRequest] = useState({
	// 	fromDate: moment(setStartDate(datePickerValues.LAST)).format(dateFormats.MM_DD_YYYY),
	// 	toDate: moment(new Date()).format(dateFormats.MM_DD_YYYY),
	// 	affiliateId,
	// });
	// useEffect(() => {
	// 	getCommissionSummaryByID(request, history);
	// }, []);

	const handleSetState = (label, value) => {
		setState({
			...state,
			[label]: value,
		});
	};
	return <CreateCommissionReportPresentational handleSetState={handleSetState} state={state} userDetails={userDetails} />;
};

const mapStateToProps = (state) => {
	return {
		userDetails: Selectors.userDetails(state),
	};
};
// const mapDispatchToProps = (dispatch) => {
// 	return {
// 		getCommissionSummaryByID: (request, history) => dispatch(Actions.creators.getCommissionSummaryByID(request, history))
// 	};
// };

const Connected = connect(mapStateToProps, null)(CreateCommissionReportFunctional);

export default Connected;
